import React from 'react';
import { Box } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common';
import s from './ProductGrid.scss';

interface Product {
  image: string;
  name: string;
}

interface ProductGridProps {
  products: Product[];
  loadedImages: Set<number>;
  activeImages: Set<number>;
  enabledImages: Set<number>;
  onImageLoad: (index: number) => void;
}

export const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  loadedImages,
  activeImages,
  enabledImages,
  onImageLoad,
}) => {
  if (!products) {
    return;
  }

  const renderProductImage = (product: Product, index: number) => (
    <Box key={index} width="32%" className={s.productWrapper}>
      <div className={`${s.imageContainer} ${enabledImages.has(index) ? s.active : ''}`}>
        <img
          src={product.image}
          alt={product.name}
          className={s.productImage}
          style={{ opacity: loadedImages.has(index) ? 1 : 0 }}
          onLoad={() => onImageLoad(index)}
        />

        {activeImages.has(index) && (
          <div className={s.iconContainer}>
            <div className={s.checkmark}>
              <Check size="16px" />
            </div>
          </div>
        )}
      </div>
    </Box>
  );

  const displayProducts = products.slice(0, 6);

  return (
    <Box direction="vertical" gap={3} width="100%" marginTop={4}>
      <Box gap={2} width="100%" align="space-between">
        {displayProducts.slice(0, 3).map((product, index) => renderProductImage(product, index))}
      </Box>

      <Box gap={2} width="100%" align="space-between">
        {displayProducts.slice(3, 6).map((product, index) => renderProductImage(product, index + 3))}
      </Box>
    </Box>
  );
};
